import React, { useState } from 'react'

import clsx from 'clsx'

import InteractiveElement from '$extensionSrc/components/InteractiveElement'

import './TabToggle.scss'

interface TabContent {
  [tabKey: string]: {
    displayName: string
    content: React.ReactNode
    url?: string
  }
}

export default function TabToggle({
  tabContentMap,
  initialTab,
}: {
  tabContentMap: TabContent
  initialTab: string
}) {
  const [selectedTab, setSelectedTab] = useState(initialTab)

  const onSelectTab = (tab) => {
    setSelectedTab(tab)
    if (tabContentMap[tab].url) {
      window.history.pushState({}, document.title, tabContentMap[tab].url)
    }
  }

  const tabNavigation = Object.entries(tabContentMap).map(
    ([tabKey, tabContent]) => {
      const tabClass = clsx(
        'tab',
        'subheading3',
        tabKey === selectedTab && 'selected',
      )
      return (
        <InteractiveElement
          aria-label={`Tab ${tabContent.displayName}`}
          key={tabKey}
          className={tabClass}
          onClick={() => onSelectTab(tabKey)}
        >
          {tabContent.displayName}
        </InteractiveElement>
      )
    },
  )

  const tabDisplayContent = Object.entries(tabContentMap).map(
    ([tabKey, tabContent]) => {
      const contentClass = clsx(
        'tab-content-item',
        tabKey === selectedTab && 'selected',
      )
      return (
        <div key={`${tabKey}-content`} className={contentClass}>
          {tabContent.content}
        </div>
      )
    },
  )

  return (
    <div className="TabToggle">
      <div className="tab-navigation cursor-pointer">{tabNavigation}</div>
      <div className="tab-content">{tabDisplayContent}</div>
    </div>
  )
}
